import { useEffect, useState } from "react";
import axios from "axios";

import { API_URL } from "../constants/constants";
import { useAuth0 } from "../hooks/react-auth0-spa";

const useCotizacionAPI = (initialBody = {}) => {
  const [body, setBody] = useState(initialBody);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { user, getTokenSilently } = useAuth0();

  useEffect(() => {
    if (Object.keys(body).length === 0) return;
    const fetchData = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        const t = await getTokenSilently();
        const r = await axios.post(API_URL + `/cotizar/${user.sub}`, body, {
          headers: {
            Authorization: `Bearer ${t}`
          }
        });
        setData(r.data);
      } catch (error) {
        setIsError(true);
      }
      setIsLoading(false);
    };
    fetchData();
    // eslint-disable-next-line
  }, [body,getTokenSilently]);

  return [{ data, isLoading, isError }, setBody];
};

export default useCotizacionAPI;
